import { render, staticRenderFns } from "./PwccFlat.vue?vue&type=template&id=6d7cba42&"
import script from "./PwccFlat.vue?vue&type=script&lang=js&"
export * from "./PwccFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports